import React from 'react';
import CompetitionDetail from '../components/competitions/CompetitionDetail';

const CompetitionDetailPage = () => {
  return <CompetitionDetail />;
};

export default CompetitionDetailPage;